import React from 'react';
import { Ticket, Trophy } from 'lucide-react';
import Modal from '../../components/Modal';
import { KIND_LIST } from './gameKinds';

const ICONS = { standalone: Ticket, league: Trophy };

/**
 * The fork between a one-off game and a mini league - the one screen where the
 * difference between them has to be explained, and so the only screen that explains it.
 *
 * Creating only. Joining looks like it needs the same fork and does not: JoinGameModal
 * already recognises a league code and offers to join the league with it, so asking
 * which kind of code somebody is holding would be a question the app can answer itself.
 */
function KindChoiceModal({ onChoose, onClose }) {
  return (
    <Modal title="Start something" onClose={onClose}>
      <div className="kind-choice">
        {KIND_LIST.map((kind) => {
          const Icon = ICONS[kind.id];
          return (
            <button
              key={kind.id}
              className="kind-choice-option"
              onClick={() => onChoose(kind.createFlow)}
            >
              <Icon size={28} className="kind-choice-icon" />
              <span className="kind-choice-label">{kind.label}</span>
              <span className="kind-choice-blurb">{kind.blurb}</span>
            </button>
          );
        })}
      </div>
    </Modal>
  );
}

export default KindChoiceModal;
